module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-relative u-flex--x u-flex--align-items--center t-lspacing--sm u-pad-t-xs@md",
    class: [_vm.itemsAreHidden ? 'is-items-hidden' : '']
  }, [(_vm.navLevel > 1) ? _c('router-link', {
    staticClass: "t-btn u-hide u-marg-l-sm u-marg-r-auto u-block@md",
    attrs: {
      "to": _vm.prevPageURL
    }
  }, [_c('img', {
    staticClass: "u-valign-middle u-marg-r-xxs",
    attrs: {
      "src": require("../../../assets/main-menu/icon-mobile_arrow-back.png"),
      "alt": "Left arrow"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-valign-bottom u-color--red-pure u-uppercase u-marg-l-xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.prevPageLabel)
    }
  })]) : _c('button', {
    staticClass: "t-btn u-hide u-marg-l-sm u-marg-r-auto u-block@md",
    on: {
      "click": _vm._toggleMenu
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/main-menu/icon-mobile_menu.png"),
      "width": "33",
      "height": "25",
      "alt": "Menu"
    }
  })]), _vm._v(" "), (_vm.contentGlobal.mainMenu.buy) ? _c('a', {
    staticClass: "t-btn u-hide u-marg-r-sm u-block@md",
    attrs: {
      "href": _vm.contentGlobal.mainMenu.buy.href,
      "target": "_blank",
      "rel": "nofollow noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.pushBuyToGTM()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/main-menu/icon-mobile_buy-ticket.png"),
      "width": "42",
      "height": "49",
      "alt": "Buy tickets"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "t-btn u-hide u-marg-r-sm u-block@md",
    on: {
      "click": function($event) {
        _vm._openModalPlay()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/main-menu/icon-mobile_start-playing.png"),
      "width": "63",
      "height": "73",
      "alt": "Start playing"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "c-menu-mobile"
    }
  }, [(_vm.isMenuOpen) ? _c('app-menu-mobile', {
    staticClass: "u-absolute u-pos-tl u-fit-w",
    attrs: {
      "content": _vm.contentGlobal.mainMenu.nav
    },
    on: {
      "close": _vm._toggleMenu
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('router-link', {
    staticClass: "c-menu__back t-text--xxs u-bold u-uppercase u-color--red-pure u-hide u-marg-l-w1of16 u-marg-r-md u-relative u-click-area--xxs u-flex__item--auto@xxl u-block@xl",
    class: {
      'is-invisible': _vm.$route.meta.key === 'home'
    },
    attrs: {
      "to": _vm.prevPageURL
    }
  }, [_c('img', {
    staticClass: "c-menu__back__arrow u-valign-middle u-marg-r-xs",
    attrs: {
      "src": require("../../../assets/main-menu/arrow-back.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-menu__back__text u-inline-block u-valign-middle",
    domProps: {
      "innerHTML": _vm._s(_vm.prevPageLabel)
    }
  })]), _vm._v(" "), _c('nav', {
    staticClass: "u-marg-x-auto u-hide@md"
  }, [_c('ul', {
    staticClass: "o-list--none o-list--inline u-color--white t-text--sm t-text--xs@lg js-menu"
  }, _vm._l((_vm.contentGlobal.mainMenu.nav), function(link, id) {
    return (id > 0) ? _c('li', {
      staticClass: "c-main-menu__row o-list__item u-relative u-valign-top u-uppercase u-marg-r-md u-marg-r-xs@lg",
      attrs: {
        "data-id": id,
        "data-menu": !!link.nav
      }
    }, [(link.nav) ? [_c('strong', {
      staticClass: "u-index--2 u-relative u-click-area--xxs",
      class: {
        'u-color--red-pure': _vm.rowOver[id]
      },
      on: {
        "click": function($event) {
          _vm._toggleSubMenu(id)
        }
      }
    }, [_c('app-text-mask', {
      staticClass: "u-marg-r-xxs",
      class: {
        'is-hover': _vm.rowOver[id]
      },
      attrs: {
        "text": link.name,
        "type": "span",
        "class-default": "u-color--white",
        "class-over": "u-color--red-pure"
      }
    }), _vm._v(" "), _vm._m(0, true)], 1), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "c-main-menu__submenu"
      }
    }, [(_vm.rowOver[id]) ? _c('ul', {
      staticClass: "c-main-menu__submenu o-list--none u-relat u-absolute u-pos-l u-block u-fit-w u-pad-t-xs u-index--1"
    }, [_vm._l((link.nav), function(subLink) {
      return _c('li', {
        staticClass: "u-block u-marg-b-xs u-relative u-index--2"
      }, [(subLink.pageLabel && _vm.pagesURL[subLink.pageLabel]) ? _c('app-text-mask', {
        staticClass: "c-main-menu__sublink u-click-area--xxs",
        attrs: {
          "to": _vm._getPageURL(subLink),
          "text": subLink.name,
          "class-default": "u-color--gray",
          "class-over": "u-color--white"
        }
      }) : (_vm.pagesURL[subLink.pageLabel]) ? _c('app-text-mask', {
        staticClass: "c-main-menu__sublink u-click-area--xxs",
        attrs: {
          "href": subLink.url,
          "type": "a",
          "text": subLink.name,
          "target": "_blank",
          "class-default": "u-color--gray",
          "class-over": "u-color--white"
        }
      }) : _vm._e()], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "c-main-menu__submenu--bg u-absolute u-index--1"
    })], 2) : _vm._e()])] : [(link.pageLabel) ? _c('app-text-mask', {
      staticClass: "c-main-menu__link u-click-area--xxs",
      attrs: {
        "to": _vm._getPageURL(link),
        "text": link.name,
        "class-default": "u-color--white",
        "class-over": "u-color--red-pure"
      }
    }) : _c('app-text-mask', {
      staticClass: "c-main-menu__link u-click-area--xxs",
      attrs: {
        "href": link.url,
        "type": "a",
        "text": link.name,
        "target": "_blank",
        "rel": "nofollow noopener noreferrer",
        "class-default": "u-color--white",
        "class-over": "u-color--red-pure"
      }
    })]], 2) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto@xxl u-align-right u-marg-t-md u-marg-b-lg u-marg-r-lg u-marg-r-xs@lg u-marg-t-xs@hmd u-hide@md"
  }, [(_vm.contentGlobal.mainMenu.buy) ? _c('app-btn', {
    staticClass: "c-btn--buy u-marg-r-xs u-marg-r-xxxs@lg",
    attrs: {
      "to": _vm.contentGlobal.mainMenu.buy.href,
      "target": "_blank",
      "rel": "nofollow noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.pushBuyToGTM()
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.mainMenu.buy.label)
    }
  })]) : _vm._e(), _vm._v(" "), _c('app-btn', {
    staticClass: "c-btn--secondary",
    on: {
      "click": function($event) {
        _vm._openModalPlay()
      }
    }
  }, [_c('span', {
    staticClass: "c-register-btn-icon__container u-inline-block"
  }, [_c('img', {
    staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-register--start-playing.png")
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "u-inline-block",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.mainMenu.play)
    }
  })])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "u-inline-block u-relative u-valign-middle"
  }, [_c('img', {
    staticClass: "u-absolute u-pos-center",
    attrs: {
      "src": require("../../../assets/main-menu/arrow-bottom-red.svg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19ae4884"}!./src/scripts/components/app-menu/template.html
// module id = 888
// module chunks = 0